// src/features/files/components/VideoPlayer.jsx
// <video> for an authenticated blob URL. Whether a file plays depends on its
// codecs, not just the container: MP4/WebM play everywhere, MKV plays in
// Chromium when it holds H.264/VP9/AV1 video. When the browser can't decode
// it we say so instead of showing a dead player.
import React, { useState } from 'react';
import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function VideoPlayer({ src, title, style }) {
  const { t } = useTranslation(['files']);
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <Alert severity="info" sx={{ m: 2 }}>
        {t('files:messages.video_unsupported')}
      </Alert>
    );
  }

  return (
    // eslint-disable-next-line jsx-a11y/media-has-caption -- user-uploaded videos have no caption tracks
    <video
      src={src}
      title={title}
      controls
      preload="metadata"
      onError={() => setFailed(true)}
      style={{ maxWidth: '100%', maxHeight: '100%', background: '#000', ...style }}
    />
  );
}

export default VideoPlayer;
